import React from 'react';

import { AllocationField } from './AllocationField';
import { NotesField } from './NotesField';
import { ReferenceFields } from './ReferenceFields';
import { ScheduleField } from './ScheduleField';
import { CreateServiceFormValues, FieldErrors } from '../types';

export interface JobDetailsTailProps {
  values: CreateServiceFormValues;
  errors: FieldErrors;
  validate: boolean;
  reference1Required: boolean;
  reference2Required: boolean;
  reference3Required: boolean;
  notesRequired: boolean;
  hasAllocationPermission: boolean;
  locked: boolean;
  updateValues: (patch: Partial<CreateServiceFormValues>) => void;
}

export const JobDetailsTail: React.FC<JobDetailsTailProps> = ({
  values,
  errors,
  validate,
  reference1Required,
  reference2Required,
  reference3Required,
  notesRequired,
  hasAllocationPermission,
  locked,
  updateValues,
}) => (
  <>
    <ReferenceFields
      reference1={values.referenceNo1}
      reference2={values.referenceNo2}
      reference3={values.referenceNo3}
      reference1Required={reference1Required}
      reference2Required={reference2Required}
      reference3Required={reference3Required}
      onChange={(key, value) => updateValues({ [key]: value })}
      errors={errors}
      locked={locked}
    />
    {hasAllocationPermission && (
      <AllocationField
        value={values.userDepotAllocation}
        onChange={(name, nodeId) =>
          updateValues({ userDepotAllocation: name, userDepotAllocationNodeId: nodeId })
        }
        locked={locked}
      />
    )}
    <ScheduleField
      value={values.scheduledAt}
      onChange={(v) => updateValues({ scheduledAt: v })}
      locked={locked}
    />
    <NotesField
      value={values.notes}
      required={notesRequired}
      onChange={(v) => updateValues({ notes: v })}
      error={validate ? errors.notes : undefined}
      locked={locked}
    />
  </>
);
